import React from 'react';
import CardCommon from '@op/components/CardCommon';
import { Col, Row } from 'tea-component';
import { useIntl } from 'umi';
import useSteamGameStoreAnalysis from '../../gamestore/hooks/useSteamGameStoreAnalysis';
import {
  steamPerformanceOnRecordTimeTips,
  steamPerformanceOnReviewTimeTips,
} from '@/pages/opinion/components/BubbleCommon';
import GameDurationChart from '../components/GameDurationChart';
import '../scss/steamGameDuration.scss';

const renderList = [
  {
    title: 'On Record Time',
    pieKey: 'record_time',
    tableKey: 'record_time_table',
    timelineKey: 'record_time_timeline',
    tipsMap: steamPerformanceOnRecordTimeTips,
  },
  {
    title: 'At Review Time',
    pieKey: 'review_time',
    tableKey: 'review_time_table',
    timelineKey: 'review_time_timeline',
    tipsMap: steamPerformanceOnReviewTimeTips,
  },
];

export default function SteamGameDuration({ filter }: any) {
  const { formatMessage } = useIntl();

  const { storeSteamData, loading } = useSteamGameStoreAnalysis({
    filter,
    metrics: [
      'record_time',
      'record_time_timeline',
      'review_time',
      'review_time_timeline',
      'total',
    ],
    initValue: {
      record_time: [],
      record_time_timeline: [],
      review_time: [],
      review_time_timeline: [],
      total: [],
    },
  });

  return (
    <CardCommon
      title={formatMessage({ id: 'Game Duration(hours)' })}
      loading={loading}
      loadingHeight={200}
      emptyHeight={200}
      className="steam-game-duration-wrapper"
    >
      <Row gap={20}>
        {renderList.map(({ title, timelineKey, tipsMap, pieKey, tableKey }) => {
          return (
            <Col key={title} span={12} className="steam-game-duration-box">
              <GameDurationChart
                pieChartData={storeSteamData[pieKey]}
                timelineChartData={storeSteamData[timelineKey]}
                tableData={storeSteamData[tableKey]}
                title={title}
                tipsMap={tipsMap}
                filter={filter}
              />
            </Col>
          );
        })}
      </Row>
    </CardCommon>
  );
}
